import {
  MANAGE_RECURRING_SAFETY_SCANS,
  OPEN_NEXT_SAFETY_CASE_WITH_NEW_ACTIVITY,
} from './safetyCasesWorkspacePresentationCopy';

export type WorkspacePrimaryTab = 'attention' | 'cases' | 'scans' | 'records';

export type WorkspacePrimaryCtaKind =
  | 'review_next_attention'
  | 'open_next_new_activity_case'
  | 'manage_recurring_scans'
  | 'none';

export type WorkspacePrimaryCta = {
  kind: WorkspacePrimaryCtaKind;
  label: string;
  testId: string;
};

function hasNewActivitySignal(value: unknown): boolean {
  const label = String(value || '').trim().toLowerCase();
  return Boolean(label) && label !== 'no' && label !== '—' && label !== '-';
}

/**
 * Resolve the single global primary CTA for the active workspace tab.
 * Deterministic: uses first Attention row / first new-activity case when present.
 */
export function resolveWorkspacePrimaryCta(input: {
  tab: WorkspacePrimaryTab;
  attentionItemCount: number;
  hasNewActivityCase: boolean;
  canManageRecurringScans: boolean;
}): WorkspacePrimaryCta {
  switch (input.tab) {
    case 'attention':
      if (input.attentionItemCount > 0) {
        return {
          kind: 'review_next_attention',
          label: 'Review next item',
          testId: 'workspace-primary-cta-review-next',
        };
      }
      return { kind: 'none', label: '', testId: 'workspace-primary-cta-none' };
    case 'cases':
      if (input.hasNewActivityCase) {
        return {
          kind: 'open_next_new_activity_case',
          label: OPEN_NEXT_SAFETY_CASE_WITH_NEW_ACTIVITY,
          testId: 'workspace-primary-cta-open-new-activity-case',
        };
      }
      return { kind: 'none', label: '', testId: 'workspace-primary-cta-none' };
    case 'scans':
      if (input.canManageRecurringScans) {
        return {
          kind: 'manage_recurring_scans',
          label: MANAGE_RECURRING_SAFETY_SCANS,
          testId: 'workspace-primary-cta-manage-scans',
        };
      }
      return { kind: 'none', label: '', testId: 'workspace-primary-cta-none' };
    case 'records':
    default:
      return { kind: 'none', label: '', testId: 'workspace-primary-cta-none' };
  }
}

export function caseRowHasNewActivity(newActivity: unknown): boolean {
  return hasNewActivitySignal(newActivity);
}
